import {
  schemaMigrations,
  addColumns,
} from '@nozbe/watermelondb/Schema/migrations';

// v1 is the implicit baseline (fresh install applies schema directly).
// Migrations must start at toVersion >= 2.
export const demoMigrations = schemaMigrations({
  migrations: [
    {
      toVersion: 2,
      steps: [
        addColumns({
          table: 'demo_products',
          columns: [
            { name: 'bp_product_has_variants', type: 'boolean' },
            { name: 'bp_product_variant_attributes', type: 'string' },
            { name: 'bp_product_variants', type: 'string' },
          ],
        }),
      ],
    },
    {
      toVersion: 3,
      steps: [
        addColumns({
          table: 'demo_cart_items',
          columns: [
            { name: 'variant_id', type: 'string', isIndexed: true },
          ],
        }),
      ],
    },
  ],
});
